import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridApi, ColDef, ICellRendererParams, GridOptions, GetRowIdParams, IServerSideGetRowsParams } from 'ag-grid-community';
import { ICellRendererAngularComp, } from 'ag-grid-angular';
import { isArray } from 'chart.js/dist/helpers/helpers.core';
import { TechnicianManagerService } from 'src/app/services/contacts/technician-manager.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { SearchOrAddTechnicianComponent } from 'src/app/modals/search-or-add-technician/search-or-add-technician.component';
import { MatButton } from '@angular/material/button';

@Component({
  template: `<span><i class="fa-solid fa-building"></i></span>`
})
export class ActionsCellRendererComponent implements ICellRendererAngularComp{
  params: any;

  refresh(){
    return true;
  }
  agInit(params: ICellRendererParams<any, any, any>){
    this.params = params;
  }
  
}

@Component({
  selector: 'app-technician-manager',
  templateUrl: './technician-manager.component.html',
  styleUrls: ['./technician-manager.component.scss']
})
export class TechnicianManagerComponent {
  constructor(private http: HttpClient, private tms: TechnicianManagerService, private toastr: ToastrService, private dialog: MatDialog){}

  theme: string = 'ag-theme-ulaap'
  gridReady: boolean = false;
  private gridApi!: GridApi;
  gridOptions: GridOptions = {
    onCellValueChanged: (event) => this.onCellValueChanged(event)
  }
  colDefs: ColDef[] = [
    { field: 'first_name', headerName: 'First Name', editable: true, sortable: true},
    { field: 'last_name', headerName: 'Last Name', editable: true, sortable: true},
    { field: 'technician_provider_name', headerName: 'Technician Provider', editable: false, sortable: true},
    { field: 'phone', headerName: 'Phone', editable: true},
    { field: 'email', headerName: 'Email', editable: true},
    { field: 'timezone', headerName: 'Timezone', editable: true},
    { field: 'city', headerName: 'Home City', editable: true},
    { field: 'region', headerName: 'Home State/Province', editable: true, sortable: true},
    { field: 'country', headerName: 'Country', editable: true, sortable: true},
    { field: 'active', headerName: 'Is Active?', editable: true},
    { field: 'actions', headerName: 'Actions', 
      cellRenderer: (params: any) => {
        const deleteButton = document.createElement('button');
        deleteButton.innerText = 'Delete';
        deleteButton.classList.add('btn', 'btn-danger');

        deleteButton.addEventListener('click', () => {
          this.deleteTechnician(params.data);
        });
        return deleteButton;
      }
    } 
  ];
  rowData: any[] = [];

  private providerGridApi!: GridApi;
  providerGridReady: boolean = false;
  providerGridOptions: GridOptions = {
    onCellValueChanged: (event) => this.onProviderCellValueChanged(event)
  }
  providerColDefs: ColDef[] = [
    { field: 'name', headerName: 'Technician Provider', editable: true, sortable: true},
    { field: 'street_address', headerName: 'Address', editable: true},
    { field: 'city', headerName: 'City', editable: true},
    { field: 'region', headerName: 'Province/State', editable: true},
    { field: 'postal_code', headerName: 'Postal/Zip Code', editable: true},
    { field: 'country', headerName: 'Country', editable: true},
    { field: 'email', headerName: 'Email', editable: true},
    { field: 'phone', headerName: 'Phone Number', editable: true}, 
    { field: 'actions', headerName: 'Actions', 
      cellRenderer: (params: any) => {
        const deleteButton = document.createElement('button');
        deleteButton.innerText = 'Delete';
        deleteButton.classList.add('btn', 'btn-danger');

        deleteButton.addEventListener('click', () => {
          this.deleteTechnicianProvider(params.data);
        });
        return deleteButton;
      }
    }
  ];
  providerRowData: any[] = [];

  ngOnInit(){
  }

  onCellValueChanged(event: any){
    if (event.oldValue === event.newValue) return;
    let url = '/api/contacts/technicians.php';
    let column = event.colDef.field;
    let payload: {[key: string]: any} = {
      'action': 'edit_technician',
      'technician_uuid': event.data.technician_uuid,
      [column]: event.newValue
    };
    console.log(payload);
    this.http.post<any>(url, payload).subscribe(
      res => {
        console.log(res);
        if(res.success && res.success === true) this.toastr.success('Technician successfully updated');
        else this.toastr.error('Technician could not be updated');
      }, 
      error => {
        console.error(error);
        this.toastr.error('Technician could not be updated');
      }
    )
  }

  deleteTechnician(data: any){
    let url = '/api/contacts/technicians.php';
    this.http.post<any>(url, { technician_uuid: data.technician_uuid, action: 'delete_technician' }).subscribe(
      res => {
        if (res.success && res.success === true){
          this.toastr.success('Technician deleted.');
          this.fetchGridData();
        } 
        else this.toastr.error('Technician not deleted.');
        console.log(res)
      }, 
      error => {
        this.toastr.error('Technician could not be deleted');
      }
    )
  }

  deleteTechnicianProvider(data: any){
    let url = '/api/contacts/technicians.php';
    this.http.post<any>(url, { technician_provider_uuid: data.technician_provider_uuid, action: 'delete_technician_provider' }).subscribe(
      res => {
        if (res.success && res.success === true){
          this.toastr.success('Technician provider deleted.');
          this.fetchProviderGridData();
        } 
        else this.toastr.error('Technician provider not deleted.');
        console.log(res)
      }, 
      error => {
        this.toastr.error('Technician provider could not be deleted');
      }
    )
  }

  onGridReady(params: any){
    this.gridApi = params.api;
    this.fetchGridData();
  }


  onProviderGridReady(params: any){
    this.providerGridApi = params.api;
    this.fetchProviderGridData();
  }

  fetchGridData(){
    const url = '/api/contacts/technicians.php?action=all_technicians';
    this.http.get<any>(url).subscribe(
      res => {
        if(Array.isArray(res)){
          this.rowData = res;
        }
        else{
          console.warn(res);
        }
        this.gridReady = true;
      },
      err => {
        console.error(err);
        this.gridReady = true;
      }
    )
  }

  fetchProviderGridData(){
    const url = '/api/contacts/technicians.php?action=all_technician_providers';
    this.http.get<any>(url).subscribe(
      res => {
        if(Array.isArray(res)){
          this.providerRowData = res;
        }
        else{
          console.warn(res);
        }
        this.providerGridReady = true;
      },
      err => {
        console.error(err);
        this.providerGridReady = true;
      }
    )
  }

  openAddTechnicianModal(){
    const ref = this.dialog.open(SearchOrAddTechnicianComponent, {
      width: '800px',
      data: {
        action: 'add_technician'
      }
    })
  }

  onProviderCellValueChanged(event: any){
    if (event.oldValue === event.newValue) return;
    let url = '/api/contacts/technicians.php';
    let column = event.colDef.field;
    let payload: {[key: string]: any} = {
      'action': 'edit_technician_provider',
      'technician_provider_uuid': event.data.technician_provider_uuid,
      [column]: event.newValue
    };
    console.log(payload);
    this.http.post<any>(url, payload).subscribe(
      res => {
        console.log(res);
        if(res.success && res.success === true) this.toastr.success('Technician provider successfully updated');
        else this.toastr.error('Technician provider could not be updated');
      }, 
      error => {
        console.error(error);
        this.toastr.error('Technician provider could not be updated');
      }
    )
  }
}
